function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#DADADA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M19.43 32.838L32.838 19.43A8.296 8.296 0 0144.57 31.162L31.162 44.57A8.296 8.296 0 0119.43 32.838"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DADADA",
  d: "M27 27l10 10z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M27 27l10 10"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DADADA",
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M39.5 47a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M38.875 40.125h2.083M38.875 40.125v-2.083"
});

var SvgDosageGrey = function SvgDosageGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDosageGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dosage_grey.5af42321.svg";
export { ForwardRef as ReactComponent };